// CPF and IDENTIFICACAO fields are saved in a separate table, but they are part of reading the file
export const IDENTIFICACAO = 'Identificação';
export const CPF = 'CPF';
export const NOME_COMPLETO = 'Nome Completo';
export const CELULAR = 'Celular';
export const DATA_DE_NASCIMENTO = 'Data de nascimento';
export const SETOR = 'Setor';
export const EMAIL = 'Email';
